<template>
    <div>
  
        SyncStatus!!!!  系统同步状态的展示!!!!!

      <el-table
    :data="tableData"
    stripe
    style="width: 100%"
    height="750"
    >
    <el-table-column
      prop="id"
      label="序号"
      width="120">
    </el-table-column>
    <el-table-column
      prop="name"
      label="变量名字"
      width="180">
    </el-table-column>

    <el-table-column
      prop="des"
      label="变量描述  "
      width="480">
    </el-table-column>
    <el-table-column
      prop="type"
      label="变量类型">
    </el-table-column>

    <el-table-column
      prop="value"
      label="变量值">
    </el-table-column>

  </el-table>



  
    </div>
  </template>
  
  <script>



export default {
    data() {
      return {
        tableData: []
      }
    },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/all_sync_status").then( (response)=>  {
this.tableData = response.data
    console.log(response.data)
  })
},

mounted:function(){
  console.log(" syncStatus   挂载完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  